import gsap from "gsap";
import Flickity from "flickity";
import * as PIXI from "pixi.js";
import { HTMLText } from "@pixi/text-html";
import LazyLoad from "vanilla-lazyload";
import Isotope from "isotope-layout";
import Zoomage from "./vendors/zoomage";
const HTML = document.querySelector("html");
class App {
  constructor() {
    this.currentTpl = 0;
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == void 0) {
          const figure = $el.closest("figure");
          if (figure)
            figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure)
          figure.classList.add("img-is-loaded");
      },
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      }
    });
    const panels = document.querySelectorAll(".panel");
    if (panels) {
      panels.forEach((panel) => {
        this.buildUI(panel);
      });
    }
    const submits = document.querySelectorAll(".submit");
    if (submits) {
      submits.forEach((submit) => {
        submit.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.add("loading");
          setTimeout(() => {
            const parent = submit.closest(".tabs-item");
            this.buildMedias(parent.querySelector(".formats"));
          }, 200);
        });
      });
    }
    const backs = document.querySelectorAll(".btn-back");
    if (backs) {
      backs.forEach((back) => {
        back.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.remove("show-render");
          const render = document.querySelector(".render:not(.init)");
          if (render) {
            gsap.to(render, { autoAlpha: 0, duration: 0.3, onComplete: () => render.remove() });
            gsap.to(document.querySelector(".main"), { autoAlpha: 1, duration: 0.4, delay: 0.3 });
          }
        });
      });
    }
    const overlay = document.querySelector(".overlay");
    if (overlay) {
      overlay.addEventListener("click", (e) => {
        HTML.classList.remove("show-overlay", "show-form");
      });
    }
    this.tabs();
    this.slider();
    this.form();
    this.isotope();
    this.step();
  }
  isotope() {
    const grids = document.querySelectorAll(".grid-isotope");
    if (grids) {
      grids.forEach((grid) => {
        var iso = new Isotope(grid, {
          itemSelector: '[class*="grid-col-"]',
          masonry: {
            columnWidth: ".grid-sizer"
          }
        });
      });
    }
  }
  step() {
    const elts = document.querySelectorAll(".step");
    if (elts) {
      elts.forEach((el) => {
        let current = 0;
        const steps = el.querySelectorAll(".step-content");
        const triggers = el.querySelectorAll("[data-step]");
        if (steps && triggers) {
          triggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              if (steps[trigger.dataset.step]) {
                if (trigger.dataset.click) {
                  const target = document.querySelector(trigger.dataset.click);
                  if (target) {
                    target.dispatchEvent(new Event("click"));
                  }
                }
                const nextStep = steps[trigger.dataset.step];
                gsap.to(steps[current], {
                  x: "-100%",
                  duration: 0.5,
                  ease: "circ.inOut"
                });
                gsap.fromTo(nextStep, {
                  x: "100%",
                  autoAlpha: 1
                }, {
                  x: "0%",
                  duration: 0.5,
                  ease: "circ.inOut",
                  onComplete: () => {
                    gsap.set(nextStep, { clearProps: "transform" });
                  }
                });
              }
            });
          });
        }
      });
    }
  }
  tabs() {
    const _ = this;
    const elts = document.querySelectorAll(".tabs");
    const tuto = document.querySelector(".tuto");
    if (elts) {
      elts.forEach((el) => {
        const triggers = el.querySelectorAll(".tabs-header a");
        const container = el.querySelector(".tabs-container");
        const items = el.querySelectorAll(".tabs-item");
        let current = 0;
        if (triggers && container && items) {
          let goto = function(index) {
            if (tuto) {
              gsap.to(tuto, { autoAlpha: 0, duration: 0.3 });
            }
            if (index == current)
              return;
            let delay = 0;
            if (current >= 0) {
              gsap.to(items[current], {
                y: "-2rem",
                duration: 0.5,
                autoAlpha: 0
              });
              triggers[current].classList.remove("active");
              delay = 0.2;
            }
            gsap.fromTo(items[index], { y: "2rem", autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5, y: "0rem", delay });
            triggers[index].classList.add("active");
            const slides = items[index].querySelectorAll(".slider .item");
            if (slides) {
              slides[0].dispatchEvent(new Event("autoplay"));
            }
            current = index;
            _.currentTpl = current;
          };
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              goto(i);
            });
          });
        }
      });
    }
  }
  slider() {
    const sliders = document.querySelectorAll(".slider");
    if (sliders) {
      sliders.forEach((slider) => {
        const nav = slider.querySelectorAll(".slider-nav a");
        const items = slider.querySelectorAll(".item");
        let current = 0;
        items.forEach((item) => {
          const v = item.querySelector("video");
          if (v && v.dataset.autoplay == "true") {
            item.addEventListener("autoplay", () => {
              v.play();
            });
            item.addEventListener("stopautoplay", () => {
              v.pause();
            });
          }
        });
        const flkty = new Flickity(slider, {
          prevNextButtons: false,
          watchCSS: true,
          cellSelector: ".item",
          on: {
            ready: () => {
              if (nav) {
                nav[current].classList.add("active");
              }
            },
            change: (index) => {
              items[index].dispatchEvent(new Event("autoplay"));
            },
            select: (index) => {
              if (nav) {
                nav[current].classList.remove("active");
                nav[index].classList.add("active");
                items[current].dispatchEvent(new Event("stopautoplay"));
                current = index;
              }
            }
          }
        });
        if (nav) {
          nav.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              flkty.select(i);
            });
          });
        }
      });
    }
  }
  async buildUI(el) {
    const templates = settings.templates;
    if (templates) {
      for (let i in templates) {
        const tpl = templates[i];
        const includes = tpl.includes;
        if (includes) {
          for (let j in includes) {
            const include = includes[j];
            if (include.includes("woff2")) {
              const names = include.match(/[ \w-]+\./);
              const fontFamily = names.length > 0 ? names[0].replaceAll(".", "") : `custom font tmp`;
              const font = new FontFace(fontFamily, `url(${include}) format("woff2")`);
              const loadedFont = await font.load();
              document.fonts.add(loadedFont);
            }
          }
        }
      }
    }
    const selectorsFormat = el.querySelectorAll(".format-list");
    if (selectorsFormat) {
      selectorsFormat.forEach((el2) => {
        const inputs = el2.querySelectorAll("input[type=checkbox]");
        const parent = el2.closest(".panel");
        const formats2 = parent.querySelectorAll(".format");
        if (inputs) {
          inputs.forEach((input, i) => {
            input.addEventListener("click", (e) => {
              if (el2.querySelectorAll("input[type=checkbox]:checked").length <= 0) {
                e.preventDefault();
                return;
              }
              if (formats2[i]) {
                if (input.checked) {
                  gsap.set(formats2[i], { autoAlpha: 1, position: "relative" });
                } else {
                  gsap.set(formats2[i], { autoAlpha: 0, position: "absolute" });
                }
              }
              window.dispatchEvent(new Event("resize"));
            });
          });
        }
      });
    }
    const formats = el.querySelectorAll(".format");
    if (formats) {
      formats.forEach((format) => {
        const attr = JSON.parse(format.dataset.attr);
        this.buildFormat(format, attr, el);
      });
    }
    const elts = el.querySelectorAll(".features");
    if (elts) {
      elts.forEach((c) => {
        const features = c.querySelectorAll(".feature");
        if (features) {
          features.forEach((feature, i) => {
            const f = this.buildFeature(feature, el);
            if (i == 0 && f.click) {
              feature.dispatchEvent(new Event("click"));
            }
          });
        }
      });
    }
  }
  async buildFormat(el, attr, parent) {
    const canvasContainer = el.querySelector(".canvas");
    if (canvasContainer) {
      canvasContainer.innerHTML = "";
      const container = document.createElement("div");
      container.classList.add("zones");
      container.style.width = `${attr.width}px`;
      container.style.height = `${attr.height}px`;
      container.style.transformOrigin = "top left";
      canvasContainer.append(container);
      let ratio = canvasContainer.offsetWidth / attr.width;
      window.addEventListener("resize", (e) => {
        ratio = canvasContainer.offsetWidth / attr.width;
        container.style.transform = `scale(${ratio})`;
      });
      window.dispatchEvent(new Event("resize"));
      if (attr.zones && attr.zones.length > 0) {
        for (let i = 0; i < attr.zones.length; i++) {
          const zone = attr.zones[i];
          const ex = "Votre texte";
          let { fontFamily } = zone;
          const textarea = document.createElement("div");
          textarea.classList.add("textarea");
          textarea.style.position = "absolute";
          textarea.style.fontFamily = fontFamily;
          textarea.style.background = zone.background && zone.background != "transparent" ? zone.background.replace("0x", "#") : "transparent";
          textarea.style.width = `${attr.width * zone.width}px`;
          textarea.style.minHeight = `${zone.lineHeight * zone.fontSize}px`;
          textarea.style.left = `${zone.x * 100}%`;
          textarea.style.transform = zone.valign == "middle" ? "translate3d(-50%, -50%, 0)" : "translate3d(-50%, 0%, 0)";
          textarea.style.fontSize = `${zone.fontSize ? Number.parseFloat(zone.fontSize) : 80}px`;
          textarea.style.textTransform = zone.textTransform;
          textarea.style.letterSpacing = zone.letterSpacing;
          textarea.style.textAlign = zone.align;
          textarea.style.fontWeight = zone.fontWeight;
          textarea.style.lineHeight = zone.lineHeight;
          textarea.style.color = zone.color.replace("0x", "#");
          textarea.style.borderColor = zone.color.replace("0x", "#");
          textarea.style.borderRadius = zone.borderRadius ? `${zone.borderRadius}px` : "35px";
          textarea.style.paddingLeft = zone.paddingLeft ? `${zone.paddingLeft}px` : "0";
          textarea.style.paddingRight = zone.paddingRight ? `${zone.paddingRight}px` : "0";
          textarea.style.paddingTop = zone.paddingTop ? `${zone.paddingTop}px` : "0";
          textarea.style.paddingBottom = zone.paddingBottom ? `${zone.paddingBottom}px` : "0";
          textarea.setAttribute("contenteditable", "true");
          textarea.setAttribute("data-zone", "true");
          textarea.style.setProperty("--padding", textarea.style.padding);
          if (zone.valign == "bottom") {
            textarea.style.bottom = `${zone.y * 100}%`;
          } else {
            textarea.style.top = `${zone.y * 100}%`;
          }
          container.append(textarea);
          textarea.addEventListener("keyup", (e) => {
            const z = parent.querySelectorAll(".zones");
            if (z) {
              z.forEach((zone2) => {
                const textareas = zone2.querySelectorAll(".textarea");
                if (textareas[i] && textareas[i] != textarea) {
                  textareas[i].innerHTML = textarea.innerHTML;
                }
              });
            }
          });
          textarea.addEventListener("focus", (e) => {
            if (textarea.innerHTML.replace(/(<([^>]+)>)/gi, "") == "")
              textarea.classList.add("focus");
            const z = parent.querySelectorAll(".zones");
            if (z) {
              z.forEach((zone2) => {
                const textareas = zone2.querySelectorAll(".textarea");
                if (textareas[i] && textarea.innerHTML.replace(/(<([^>]+)>)/gi, "") == "") {
                  textareas[i].classList.add("focus");
                }
              });
            }
          });
          textarea.addEventListener("blur", (e) => {
            const z = parent.querySelectorAll(".zones");
            if (z) {
              z.forEach((zone2) => {
                const textareas = zone2.querySelectorAll(".textarea");
                if (textareas[i] && textarea.innerHTML.replace(/(<([^>]+)>)/gi, "") == "" && (textareas[i].innerHTML == "" || textareas[i].innerHTML == "<br>")) {
                  textareas[i].classList.remove("focus");
                }
              });
            }
          });
        }
      }
    }
  }
  buildFeature(el, parent) {
    let click = true;
    let attrs = JSON.parse(el.dataset.options);
    for (let i in attrs) {
      const attr = attrs[i];
      if (attr.target == "upload") {
        click = false;
        const canvas = parent.querySelectorAll(".format .canvas");
        if (canvas) {
          canvas.forEach((c, i2) => {
            c.closest(".format").classList.add("format-upload");
            const zoomageEl = document.createElement("div");
            zoomageEl.classList.add("zoomage");
            gsap.set(zoomageEl, {
              position: "absolute",
              top: attr.y && attr.y[i2] ? `${attr.y[i2] * 100}%` : 0,
              left: attr.x && attr.x[i2] ? `${attr.x[i2] * 100}%` : 0,
              width: attr.width && attr.width[i2] ? `${attr.width[i2] * 100}%` : "100%",
              height: attr.height && attr.height[i2] ? `${attr.height[i2] * 100}%` : "100%",
              overflow: "hidden"
            });
            c.parentNode.prepend(zoomageEl);
          });
        }
        const file = document.createElement("input");
        file.type = "file";
        file.accept = "image/*";
        el.addEventListener("click", (e) => {
          e.preventDefault();
          file.click();
        });
        file.addEventListener("change", (e) => {
          const file2 = e.target.files[0];
          let fileReader = new FileReader();
          fileReader.readAsDataURL(file2);
          fileReader.onload = function() {
            if (canvas) {
              canvas.forEach((c) => {
                const zoomageEl = c.parentNode.querySelector(".zoomage");
                zoomageEl.innerHTML = "";
                const oldControl = zoomageEl.parentNode.querySelector(".control-zoomage");
                if (oldControl)
                  oldControl.remove();
                const z = new Zoomage({
                  container: zoomageEl,
                  enableDesktop: true,
                  enableGestureRotate: true,
                  minZoom: 0.05
                });
                z.load(fileReader.result);
                zoomageEl.zoomage = z;
                const control = document.createElement("div");
                control.classList.add("control-zoomage");
                zoomageEl.parentNode.append(control);
                const rangeZoom = document.createElement("input");
                let baseZoom = 0;
                rangeZoom.setAttribute("type", "range");
                rangeZoom.setAttribute("min", "0");
                rangeZoom.setAttribute("max", "1000");
                rangeZoom.classList.add("zoom-range");
                rangeZoom.value = 500;
                rangeZoom.addEventListener("input", () => {
                  if (baseZoom == 0)
                    baseZoom = z.zoomD;
                  const currentZoom = (rangeZoom.value - 500) / 500;
                  const newScale = currentZoom >= 0 ? baseZoom + (z.maxZoom - baseZoom) * currentZoom : baseZoom - (baseZoom - z.minZoom) * Math.abs(currentZoom);
                  z.isOnTouching = true;
                  z.zoomD = newScale;
                  z._runCallback("onZoom");
                });
                control.append(rangeZoom);
                const triggerZoomMore = document.createElement("a");
                triggerZoomMore.classList.add("zoom-more");
                triggerZoomMore.addEventListener("click", (e2) => {
                  e2.preventDefault();
                  z.zoom(0.05);
                });
                const triggerZoomLess = document.createElement("a");
                triggerZoomLess.classList.add("zoom-less");
                triggerZoomLess.addEventListener("click", (e2) => {
                  e2.preventDefault();
                  z.zoom(-0.05);
                });
                function centerCanvas(boundContainer) {
                  const newPosX = (boundContainer.width - z.canvas.width) / 2;
                  const newPosY = (boundContainer.height - z.canvas.height) / 2;
                  z.moveXD = newPosX;
                  z.moveYD = newPosY;
                }
                const triggerZoomWidth = document.createElement("a");
                triggerZoomWidth.classList.add("zoom-width");
                triggerZoomWidth.addEventListener("click", (e2) => {
                  e2.preventDefault();
                  const boundContainer = z.container.getBoundingClientRect();
                  z.zoomD = boundContainer.width / z.canvas.width;
                  centerCanvas(boundContainer);
                });
                control.append(triggerZoomWidth);
                const triggerZoomHeight = document.createElement("a");
                triggerZoomHeight.classList.add("zoom-height");
                triggerZoomHeight.addEventListener("click", (e2) => {
                  e2.preventDefault();
                  const boundContainer = z.container.getBoundingClientRect();
                  z.zoomD = boundContainer.height / z.canvas.height;
                  centerCanvas(boundContainer);
                });
                control.append(triggerZoomHeight);
              });
            }
          };
        });
      }
    }
    el.addEventListener("click", (e) => {
      attrs = JSON.parse(el.dataset.options);
      e.preventDefault();
      const activesElt = el.closest(".features").querySelectorAll(".active");
      if (activesElt) {
        activesElt.forEach((active) => active.classList.remove("active"));
      }
      el.classList.add("active");
      for (let i in attrs) {
        const attr = attrs[i];
        if (attr.target == "selectedText") {
        } else if (attr.target == "upload") {
          el.classList.remove("active");
        } else if (attr.target == "dependency") {
          const v = attr.values;
          const targets = parent.querySelectorAll(`[data-key='${attr.dependency}']`);
          if (targets) {
            targets.forEach((target, i2) => {
              const newEltValues = v[i2];
              const options = JSON.parse(target.dataset.options);
              if (newEltValues && options) {
                for (let o in options) {
                  options[o].values = newEltValues[o];
                }
              }
              target.setAttribute("data-options", JSON.stringify(options));
            });
            const active = parent.querySelector(`[data-key='${attr.dependency}'].active`);
            if (active)
              active.dispatchEvent(new Event("click"));
          }
        } else {
          const formats = parent.querySelectorAll(".format");
          if (formats) {
            formats.forEach((format, i2) => {
              let value = "";
              if (typeof attr.values == "object") {
                value = attr.values[i2] ? attr.values[i2] : attr.values[0];
              } else {
                value = attr.values;
              }
              const targets = format.querySelectorAll(`[data-${attr.target}]`);
              if (targets) {
                targets.forEach((target) => {
                  if (attr.property) {
                    target.setAttribute(attr.property, value);
                    if (value.indexOf("mp4") >= 0 || value.indexOf("webm") >= 0) {
                      gsap.set(target, { autoAlpha: 0 });
                      target.addEventListener("canplay", (e2) => {
                        gsap.to(target, { autoAlpha: 1, duration: 0.3 });
                      });
                      target.play();
                    }
                  } else {
                    target.style[attr.style] = value;
                  }
                });
              }
            });
          }
        }
      }
    });
    return { "click": click };
  }
  async buildMedias(el) {
    if (el) {
      const data = [];
      const allFormats = el.querySelectorAll(".format");
      if (allFormats) {
        let formats = [];
        const selectors = el.querySelectorAll(".format-list input[type=checkbox]");
        if (selectors) {
          selectors.forEach((selector, i) => {
            if (selector.checked && allFormats[i]) {
              formats.push(allFormats[i]);
            }
          });
        }
        await Promise.all(formats.map(async (format, i) => {
          const attr = JSON.parse(format.dataset.attr);
          const photo = await this.bgUploaded(format, attr);
          const img = await this.screenshot(format.querySelector(".zones"), attr);
          const bg = format.querySelector("[data-bg]").getAttribute("src");
          data.push({
            type: format.querySelector(".export input:checked").value,
            slug,
            photo,
            img,
            bg,
            width: attr.width,
            height: attr.height
          });
        }));
        const body = new FormData();
        body.append("data", JSON.stringify(data));
        body.append("action", "build");
        fetch("./inc/.ajax.php", {
          method: "POST",
          body
        }).then(function(res) {
          return res.json();
        }).then((data2) => {
          if (data2.statut) {
            const medias = data2.medias;
            HTML.classList.remove("loading");
            HTML.classList.add("show-render");
            const panel = document.querySelector(".render").cloneNode(true);
            panel.classList.remove("init");
            document.body.append(panel);
            if (panel) {
              panel.classList.add("show");
              const slider = panel.querySelector(".slider-render");
              const base = panel.querySelector(".base");
              const flkty = new Flickity(slider, {
                prevNextButtons: false,
                cellSelector: ".item",
                watchCSS: true
              });
              for (let i in medias) {
                const media = medias[i];
                const slide = base.cloneNode(true);
                const containerMedia = slide.querySelector(".media");
                slide.classList.remove("opacity-0", "invisible", "base", "absolute");
                let el2 = document.createElement("img");
                if (media.indexOf(".mp4") >= 0 || media.indexOf("webm") >= 0) {
                  el2 = document.createElement("video");
                  el2.muted = true;
                  el2.loop = true;
                  el2.autoplay = true;
                  el2.playsinline = true;
                  el2.play();
                }
                el2.classList.add("max-w-[90%]", "max-h-[90%]", "mx-auto", "js-lazy");
                el2.src = media;
                containerMedia.append(el2);
                const btn = document.createElement("a");
                btn.classList.add("btn", "mt-4");
                btn.innerHTML = "<span>Enregistrer</span>";
                btn.addEventListener("click", async (e) => {
                  e.preventDefault();
                  const blob = await fetch(media).then((res) => res.blob());
                  const name = media.substring(media.lastIndexOf("/") + 1);
                  await this.shareOrDownload(blob, name, "", "");
                });
                containerMedia.append(btn);
                const form = document.querySelector(".form-mail form");
                if (form) {
                  form.querySelector('input[name="medias"]').value = JSON.stringify(medias);
                  const triggerMail = panel.querySelector(".trigger-mail");
                  if (triggerMail) {
                    triggerMail.addEventListener("click", (e) => {
                      HTML.classList.add("show-overlay", "show-form");
                      form.querySelector("input[name='email']").focus();
                    });
                  }
                }
                if (window.innerWidth < 1024) {
                  flkty.append(slide);
                } else {
                  slider.append(slide);
                }
              }
              gsap.to(document.querySelector(".main"), { autoAlpha: 0, duration: 0.4 });
              gsap.to(panel, { autoAlpha: 1, duration: 0.4, delay: 0.15 });
              gsap.from(slider, { autoAlpha: 0, x: "5rem", duration: 0.4, ease: "expo.out", delay: 0.25 });
            }
          }
        });
      }
    }
  }
  async bgUploaded(el, attr, index) {
    const zoomage = el.querySelector(".zoomage canvas");
    if (zoomage) {
      const photo = zoomage.toDataURL("image/png", 1);
      const app = new PIXI.Application({
        width: attr.width,
        height: attr.height,
        backgroundColor: 0,
        backgroundAlpha: 0,
        antialias: true
      });
      document.body.append(app.view);
      const container = new PIXI.Container();
      app.stage.addChild(container);
      container.x = 0;
      container.y = 0;
      container.width = app.renderer.width;
      container.height = app.renderer.height;
      const parent = zoomage.closest(".zoomage");
      const boundParent = parent.parentNode.getBoundingClientRect();
      const boundZone = parent.getBoundingClientRect();
      const boundPhoto = zoomage.getBoundingClientRect();
      const top = (boundZone.y - boundParent.y) / boundParent.width * app.renderer.width;
      const left = (boundZone.x - boundParent.x) / boundParent.height * app.renderer.height;
      const width = boundZone.width / boundParent.width * app.renderer.width;
      const height = boundZone.height / boundParent.height * app.renderer.height;
      const square = new PIXI.Graphics();
      square.beginFill(0);
      square.drawRect(0, 0, app.renderer.width, app.renderer.height);
      square.endFill();
      square.cacheAsBitmap = true;
      container.addChild(square);
      const sheet = await PIXI.Assets.load(photo);
      const sprite = new PIXI.Sprite(sheet);
      sprite.anchor.set(0.5);
      sprite.width = boundPhoto.width / boundParent.width * app.renderer.width;
      sprite.height = boundPhoto.height / boundParent.height * app.renderer.height;
      sprite.x = (boundPhoto.x - boundParent.x) / boundPhoto.width * sprite.width + sprite.width * 0.5;
      sprite.y = (boundPhoto.y - boundParent.y) / boundPhoto.height * sprite.height + sprite.height * 0.5;
      sprite.angle = gsap.getProperty(zoomage, "rotate");
      container.addChild(sprite);
      const mask = new PIXI.Graphics();
      mask.beginFill(6684672);
      mask.drawRect(left, top, width, height);
      mask.endFill();
      sprite.mask = mask;
      const base64 = await app.renderer.extract.base64(app.stage, "image/png", 1);
      app.destroy(true);
      const body = new FormData();
      body.append("media", base64);
      body.append("action", "savePhoto");
      const response = await fetch("./inc/.ajax.php", {
        method: "POST",
        body
      });
      const output = await response.json();
      if (output && output.statut) {
        return output.filename;
      }
      return false;
    }
    return false;
  }
  async screenshot(el, attr) {
    const canvas = document.createElement("canvas");
    const clone = el.cloneNode(true);
    clone.style.transform = "";
    clone.style.position = "absolute";
    clone.style.opacity = 0;
    clone.style.pointerEvents = "none";
    document.body.append(clone);
    const boundP = clone.getBoundingClientRect();
    const app = new PIXI.Application({
      view: canvas,
      width: attr.width,
      height: attr.height,
      backgroundColor: 0,
      backgroundAlpha: 0,
      antialias: true
    });
    const container = new PIXI.Container();
    app.stage.addChild(container);
    container.x = 0;
    container.y = 0;
    container.width = app.renderer.width;
    container.height = app.renderer.height;
    const zones = clone.querySelectorAll(".textarea");
    if (zones) {
      await Promise.all(Array.from(zones).map(async (zone, i) => {
        const param = attr.zones[i];
        const bound = zone.getBoundingClientRect();
        const eltsDel = zone.querySelectorAll("br[data-mce-bogus]");
        if (eltsDel) {
          eltsDel.forEach((eldel) => eldel.remove());
        }
        const content = zone.innerHTML.replaceAll("<p>", "").replaceAll("</p>", "<br>");
        const text = new HTMLText(content, {
          fontFamily: zone.style.fontFamily,
          fontSize: zone.style.fontSize ? Number.parseFloat(zone.style.fontSize) : 80,
          align: zone.style.textAlign,
          fontWeight: Number.parseFloat(zone.style.fontWeight),
          lineHeight: Number.parseFloat(zone.style.lineHeight) * Number.parseFloat(zone.style.fontSize),
          textTransform: zone.style.textTransform,
          letterSpacing: zone.style.letterSpacing,
          breakWords: true,
          wordWrap: true,
          wordWrapWidth: app.renderer.width * param.width - (param.paddingLeft ? param.paddingLeft : 0) - (param.paddingRight ? param.paddingRight : 0),
          fill: zone.style.color,
          backgroundColor: 16773120
        });
        if (zone.style.textAlign == "right") {
          text.x = bound.x - boundP.x + bound.width - (param.paddingRight ? param.paddingRight : 0);
          text.anchor.x = 1;
        } else if (zone.style.textAlign == "left") {
          text.x = bound.x - boundP.x;
          text.anchor.x = 0;
        } else {
          text.x = bound.x - boundP.x + bound.width / 2;
          text.anchor.x = 0.5;
        }
        text.y = bound.y - boundP.y + bound.height / 2 + (param.paddingTop ? param.paddingTop / 2 : 0) - (param.paddingBottom ? param.paddingBottom / 2 : 0);
        text.anchor.y = 0.5;
        if (zone.style.background != "transparent") {
          var graphics = new PIXI.Graphics();
          graphics.beginFill(16777215);
          graphics.drawRoundedRect(bound.x - boundP.x, bound.y - boundP.y, bound.width, bound.height, Number.parseFloat(zone.style.borderRadius));
          container.addChild(graphics);
        }
        const includes = settings.templates[this.currentTpl].includes;
        for (let j in includes) {
          const include = includes[j];
          if (include.indexOf(zone.style.fontFamily) >= 0) {
            await text.style.loadFont(include, {
              family: zone.style.fontFamily
            });
            ;
          }
        }
        container.addChild(text);
        await this.sleep();
      }));
      await this.waitFor(1e3);
      const base64 = app.renderer.view.toDataURL("image/png", 1);
      app.destroy(true);
      clone.remove();
      return base64;
    }
  }
  form() {
    const form = document.querySelector(".form-mail form");
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const body = new FormData(e.target);
        body.append("action", "sendMail");
        HTML.classList.add("loading");
        fetch("./inc/.ajax.php", {
          method: "POST",
          body
        }).then(function(res) {
          return res.json();
        }).then((data) => {
          if (data.msg) {
            const msg = document.createElement("div");
            msg.classList.add("msg");
            msg.innerHTML = data.msg;
            document.body.append(msg);
            gsap.to(msg, { duration: 0.3, autoAlpha: 1, onComplete: () => {
              setTimeout(() => {
                HTML.classList.remove("loading");
                if (data.statut) {
                  HTML.classList.remove("show-overlay", "show-form");
                }
                gsap.to(msg, { autoAlpha: 0, duration: 0.3, onComplete: () => {
                  msg.remove();
                } });
              }, 3e3);
            } });
          }
        });
        return false;
      });
    }
  }
  async sleep() {
    return new Promise(requestAnimationFrame);
  }
  async waitFor(ms) {
    return new Promise((r) => setTimeout(r, ms));
  }
  async shareOrDownload(blob, fileName, title, text) {
    const webShareSupported = "canShare" in navigator;
    if (webShareSupported) {
      const data = {
        files: [
          new File([blob], fileName, {
            type: blob.type
          })
        ],
        title,
        text
      };
      if (navigator.canShare(data)) {
        try {
          await navigator.share(data);
        } catch (err) {
          if (err.name !== "AbortError") {
            console.error(err.name, err.message);
          }
        } finally {
          return;
        }
      }
    }
    const a = document.createElement("a");
    a.download = fileName;
    a.style.display = "none";
    a.href = URL.createObjectURL(blob);
    a.addEventListener("click", () => {
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
        a.remove();
      }, 1e3);
    });
    document.body.append(a);
    a.click();
  }
}
window.addEventListener("load", () => {
  new App();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
